<template>
    <div v-if="question">
        <div class="question__question">
            <span v-bind:inner-html.prop="question.question | marked | noParagraph"></span>
            <span class="question__required" v-if="isRequired">*</span>
            <template v-if="askingPersonalInformation">
                <span class="question__show-asked-to"
                      v-if="question.askQuestion === 'all-guests'"
                      v-on:mouseenter="showTooltipAllGuests = true"
                      v-on:mouseleave="showTooltipAllGuests = false">
                    <i class="fas fa-male adult"></i>
                    <i class="fas fa-male adult"></i>
                    <i class="fas fa-male adult"></i>
                    <i class="fas fa-male adult"></i>
                    <!--                <i class="fas fa-child child"></i>-->
                    <!--                <i class="fas fa-child child"></i>-->
                    <tooltip v-bind:visible="showTooltipAllGuests" v-bind:position="'bottom-left'" v-bind:text="'Asked of all guests'"></tooltip>
                </span>

                <span class="question__show-asked-to"
                      v-if="question.askQuestion === 'adult-guests'"
                      v-on:mouseenter="showTooltipAdults = true"
                      v-on:mouseleave="showTooltipAdults = false">
                    <i class="fas fa-male adult"></i>
                    <i class="fas fa-male adult"></i>
                    <i class="fas fa-male adult"></i>
                    <i class="fas fa-male adult"></i>
                        <!--                <i class="fas fa-child child child&#45;&#45;not-asked"></i>-->
                        <!--                <i class="fas fa-child child child&#45;&#45;not-asked"></i>-->
                    <tooltip v-bind:visible="showTooltipAdults" v-bind:position="'bottom-left'" v-bind:text="'Asked of all adults'"></tooltip>
                </span>
                    <span class="question__show-asked-to"
                          v-if="question.askQuestion === 'children-guests'"
                          v-on:mouseenter="showTooltipChildren = true"
                          v-on:mouseleave="showTooltipChildren = false">
    <!--                <i class="fas fa-male adult adult&#45;&#45;not-asked"></i>-->
                        <!--                <i class="fas fa-male adult adult&#45;&#45;not-asked"></i>-->
                        <!--                <i class="fas fa-male adult"></i>-->
                        <!--                <i class="fas fa-male adult"></i>-->
                    <i class="fas fa-child child"></i>
                    <i class="fas fa-child child"></i>
                    <tooltip v-bind:visible="showTooltipChildren" v-bind:position="'bottom-left'" v-bind:text="'Asked of all children'"></tooltip>
                </span>
                    <span class="question__show-asked-to"
                          v-if="question.askQuestion === 'adult-first'"
                          v-on:mouseenter="showTooltipFirstAdult = true"
                          v-on:mouseleave="showTooltipFirstAdult = false">
                    <i class="fas fa-male adult"></i>
                    <i class="fas fa-male adult adult--not-asked"></i>
                    <i class="fas fa-male adult adult--not-asked"></i>
                    <i class="fas fa-male adult adult--not-asked"></i>
                        <!--                <i class="fas fa-child child child&#45;&#45;not-asked"></i>-->
                        <!--                <i class="fas fa-child child child&#45;&#45;not-asked"></i>-->
                    <tooltip v-bind:visible="showTooltipFirstAdult" v-bind:position="'bottom-left'" v-bind:text="'Asked of the first adult only'"></tooltip>
                </span>
                    <span class="question__show-asked-to"
                          v-if="question.askQuestion === 'adult-second'"
                          v-on:mouseenter="showTooltipAdultSecond = true"
                          v-on:mouseleave="showTooltipAdultSecond = false">
                    <i class="fas fa-male adult adult--not-asked"></i>
                    <i class="fas fa-male adult"></i>
                    <i class="fas fa-male adult adult--not-asked"></i>
                    <i class="fas fa-male adult adult--not-asked"></i>
                        <!--                <i class="fas fa-child child child&#45;&#45;not-asked"></i>-->
                        <!--                <i class="fas fa-child child child&#45;&#45;not-asked"></i>-->
                    <tooltip v-bind:visible="showTooltipAdultSecond" v-bind:position="'bottom-left'" v-bind:text="'Asked of the second adult only'"></tooltip>
                </span>
                    <span class="question__show-asked-to"
                          v-if="question.askQuestion === 'adult-first-and-second'"
                          v-on:mouseenter="showTooltipAdultFirstAndSecond = true"
                          v-on:mouseleave="showTooltipAdultFirstAndSecond = false">
                    <i class="fas fa-male adult"></i>
                    <i class="fas fa-male adult"></i>
                    <i class="fas fa-male adult adult--not-asked"></i>
                    <i class="fas fa-male adult adult--not-asked"></i>
                        <!--                <i class="fas fa-child child child&#45;&#45;not-asked"></i>-->
                        <!--                <i class="fas fa-child child child&#45;&#45;not-asked"></i>-->
                    <tooltip v-bind:visible="showTooltipAdultFirstAndSecond" v-bind:position="'bottom-left'" v-bind:text="'Asked of the first and second adults'"></tooltip>
                </span>
            </template>
        </div>

        <div v-if="question.note" class="question__note">
            <div v-bind:inner-html.prop="question.note | marked" class="question__note-inner"></div>
        </div>

        <div class="question__answer">
            <div v-if="isTime">
                <input type="text" v-model="answer" class="short-question" disabled/>
            </div>

            <div v-if="isDate" class="question__answer--input-with-button">
                <input type="text" v-model="answer" class="short-question" disabled/>
                <a title="toggle" data-toggle>
                    <i class="fas fa-calendar-alt"></i>
                </a>
            </div>

            <div v-if="isDateOfBirth" class="question__answer--input-with-button">
                <input type="text" v-model="answer" class="short-question" disabled/>
                <a title="toggle" data-toggle>
                    <i class="fas fa-calendar-alt"></i>
                </a>
            </div>

            <div v-if="isIDNumber" class="">
                <input type="text" v-model="answer" class="short-question" disabled />
            </div>

            <div v-if="isEmail" class="question__answer--copyable-input">
                <input type="email" v-model="answer" class="short-question" disabled/>
            </div>

            <div v-if="isShortAnswer || isFirstName || isLastName" class="question__answer--copyable-input">
                <input type="text" v-model="answer" class="short-question" disabled/>
            </div>

            <div v-if="isMobile" class="question__answer--copyable-input">
                <vue-tel-input v-model="answer" v-bind:disabled="true">
                    <template v-slot:arrow-icon>
                        <span>▼</span>
                    </template>
                </vue-tel-input>
            </div>

            <div v-if="isParagraph" class="question__answer--copyable-input">
                <textarea v-model="answer" class="long-question" ref="resizeableTextarea" disabled/>
            </div>

            <div v-if="isMultipleChoice" class="answer-group" v-bind:class="{'answer-group--horizontal' : question.displayOptionsHorizontally}">
                <label v-for="option in question.options" v-bind:key="option">
                    <input type="radio" v-model="answer" v-bind:value="option" disabled/>{{option}}
                </label>
            </div>

            <div v-if="isCheckBoxes" class="answer-group" v-bind:class="{'answer-group--horizontal' : question.displayOptionsHorizontally}">
                <label v-for="option in question.options" v-bind:key="option">
                    <input type="checkbox" v-model="answer" v-bind:value="option"
                           true-value="true" false-value="false" disabled/>{{option}}
                </label>
            </div>

            <div v-if="isDropDown" class="answer-group">
                <select v-model="answer" disabled>
                    <option v-for="option in question.options" v-bind:key="option" v-bind:value="option">{{option}}</option>
                </select>
            </div>

            <div v-if="isCountry" class="answer-group">
                <select v-model="answer" disabled>
                    <option selected>Select</option>
                    <option value="ZAF">South Africa</option>
                </select>
            </div>

            <div v-if="isImage" class="answer-group">
                <input type="file" disabled/>
            </div>

            <div v-if="isSignature" class="signature-container">
                <div class="signature__preview">
                    <img src="@/assets/signature_placeholder.png" alt="Signature Preview" class="signature-image"/>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import * as dayjs from 'dayjs'

    import Tooltip from '../Tooltip'

    const VueTelInput = () =>
        Promise.all([
            import(/* webpackChunkName: "chunk-vue-tel-input" */ 'vue-tel-input'),
            import(/* webpackChunkName: "chunk-vue-tel-input" */ 'vue-tel-input/dist/vue-tel-input.css')
        ]).then(([{ VueTelInput }]) => VueTelInput)

    export default {
        name: 'QuestionPreview',
        components: { Tooltip, VueTelInput },
        props: {
            question: Object,
            askingPersonalInformation: Boolean
        },
        data: function () {
            return {
                answer: "",
                exampleDate: dayjs().format("D MMMM YYYY"),
                showTooltipAllGuests: false,
                showTooltipAdults: false,
                showTooltipChildren: false,
                showTooltipFirstAdult: false,
                showTooltipAdultSecond: false,
                showTooltipAdultFirstAndSecond: false
            }
        },
        filters: {
            noParagraph: function (value) {
                if (!value) {
                    return '';
                }
                value = value.toString();
                return value.replace(/<p>/i, '').replace(/<\/p>/i, '');
            },
        },
        computed: {
            isTime: function () {
                return String(this.question.type) === 'time'
            },
            isFirstName: function () {
                return String(this.question.type) === 'first-name'
            },
            isLastName: function () {
                return String(this.question.type) === 'last-name'
            },
            isEmail: function () {
                return String(this.question.type) === 'email'
            },
            isMobile: function () {
                return String(this.question.type) === 'mobile'
            },
            isIDNumber: function () {
                return String(this.question.type) === 'id-number'
            },
            isShortAnswer: function () {
                return String(this.question.type) === 'short-answer'
            },
            isMultipleChoice: function () {
                return String(this.question.type) === 'multiple-choice'
            },
            isCheckBoxes: function () {
                return String(this.question.type) === 'checkboxes'
            },
            isDropDown: function () {
                return String(this.question.type) === 'dropdown'
            },
            isParagraph: function () {
                return String(this.question.type) === 'paragraph'
            },
            isCountry: function () {
                return String(this.question.type) === 'country'
            },
            isDate: function () {
                return String(this.question.type) === 'date'
            },
            isDateOfBirth: function () {
                return String(this.question.type) === 'date-of-birth'
            },
            isImage: function () {
                return String(this.question.type) === 'image'
            },
            isSignature: function () {
                return String(this.question.type) === 'signature'
            },
            isRequired: function() {
                return this.question.required;
            }
        },
        watch: {
            question: {
                handler: function () {
                    this.answer = this.getAnswer();
                },
                deep: true
            }
        },
        methods: {
            getAnswer: function() {
                if (this.question) {
                    switch (this.question.type) {
                        case 'id-number':
                            return "ID number";
                        case 'date':
                            return this.exampleDate;
                        case 'date-of-birth':
                            return this.exampleDate;
                        case 'time':
                            return "14:00";
                        case 'country':
                            return "ZAF";
                        case 'first-name':
                            return "first name";
                        case 'last-name':
                            return "last name";
                        case 'email':
                            return "email address";
                        case 'mobile':
                            return "+27 812345678";
                        case 'short-answer':
                            return "short answer";
                        case 'paragraph':
                            return "paragraph";
                        case 'checkboxes':
                            return "checkboxes";
                        case 'multiple-choice':
                        case 'dropdown':
                            if (this.question.options.length > 0) {
                                return this.question.options[0];
                            } else {
                                return "";
                            }
                        default:
                            return "";
                    }
                }
                return "";
            },
        },
        mounted() {
            this.answer = this.getAnswer();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/components/_question_answer.scss";
</style>
